module.exports = __webpack_public_path__ + "static/media/1.2a4eb992.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16465/1.jpg
// module id = 563
// module chunks = 0